/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  HeroSection,
  EditProfileModal,
  UpdateModal,
  Header,
} from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMprofilePage,
  useSMupdateProfile,
} from '@pages/ProfilePage/machines';
import { ProfilePageService } from '@pages/ProfilePage/services';

const getSrv = () => {
  return vappContainer.get<ProfilePageService>(ProfilePageService.displayName);
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const theme = useTheme();
  const srv = getSrv();

  const { profilePageMachine, profilePageSend, profilePageState } =
    useSMprofilePage({});
  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };

  const onEditProfile = (
    name: string,
    description: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ) => {
    const payload: any = {};
    if (name) {
      payload.name = name;
    }
    if (description) {
      payload.description = description;
    }
    if (phoneNumber) {
      payload.telephone = phoneNumber;
    }
    if (address) {
      payload.address = {
        addressLine1: address,
      };
    }
    if (website) {
      payload.website = website;
    }
    if (profileImg) {
      payload.logo = profileImg;
    }
    updateProfileSend('START', {
      payload: payload,
    });
  };

  const onRefresh = () => {
    profilePageSend('TRIGGER_REFRESH', {});
  };

  const onUpdateProfile = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    updateProfileSend('START', {
      payload: {
        ...data,
      },
    });
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          // size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdateProfile}
          onHide={() => setShowModal(false)}
          title={'Update Profile'}
          tweetyWidgetProps={{
            fields: srv?.agent?.getStaticPageSync()?.editProfile?.FIELDS,
            layout: srv?.agent?.getStaticPageSync()?.editProfile?.layout,
            validatorConfig:
              srv?.agent?.getStaticPageSync()?.editProfile?.validatorConfig,
            initialData: profilePageState?.event?.data?.value?.initialData,
          }}
        />
      );
    }
  };

  const _renderProfile = () => {
    if (profilePageState?.matches('GET_PROFILE_CONTENT')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingMyProfileSync()?.loading?.loadingProfile ||
            {})}
        />
      );
    }
    if (profilePageState?.matches('RENDER_PROFILE')) {
      console.log('render page', profilePageState?.event?.data?.value);
      return (
        <>
          <HeroSection
            {...(profilePageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
        </>
      );
    }

    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticPageSync()?.loading?.loadingProfile || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getStaticPageSync()?.header) {
      return (
        <>
          <Header {...(srv?.agent?.getStaticPageSync()?.header || {})} />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderProfile()}
        {_renderModal()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
